module.exports = __webpack_public_path__ + "static/media/238-thailand.92466bfd.svg";